module.exports = __webpack_public_path__ + "static/media/em-02.ea4a5ca0.png";